import { render, staticRenderFns } from "./citizenship_status.vue?vue&type=template&id=6cdcfd64&"
import script from "./citizenship_status.vue?vue&type=script&lang=js&"
export * from "./citizenship_status.vue?vue&type=script&lang=js&"
import style0 from "./citizenship_status.vue?vue&type=style&index=0&id=6cdcfd64&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports